import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReportingProps from '@bingads-webui-campaign-react/props-reporting';
import { BackboneInstanceWrapper } from '@bingads-webui-react/backbone-instance-wrapper';
import { ColumnChooser as BackboneColumnChooser } from '@bingads-webui/column-chooser';
import { helpers } from '@bingads-webui/deterministic-view';

// a fork of `column-chooser.js` in @bingads-webui-campaign/report-column-chooser
export class ColumnChooser extends Component {
  static propTypes = {
    categories: PropTypes.array.isRequired, // eslint-disable-line
    currentActive: PropTypes.string,
    legacyI18n: PropTypes.object.isRequired, // eslint-disable-line
    selected: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    onApply: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    simplified: PropTypes.bool.isRequired,
    isSplittingSelectedArea: PropTypes.bool.isRequired,
    instrumentation: ReportingProps.instrumentation, // eslint-disable-line
  };

  static defaultProps = {
    currentActive: '',
  }

  constructor(props) {
    super(props);
    const {
      categories,
      selected,
      legacyI18n,
      onApply,
      onCancel,
      isSplittingSelectedArea,
      simplified,
      instrumentation,
    } = props;

    const cfg = {
      categories,
      selected,
    };
    this.state = {
      searchStr: '',
    };
    this.view = new BackboneColumnChooser({
      i18n: legacyI18n,
      simplified,
      isSplittingSelectedArea,
      instrumentation,
    }).setState(cfg);

    this.view.on(
      'hide',
      ({
        selectedKeys,
        savedName,
        currentActive,
        searchStr,
      } = {}) => {
        const isApply = !!selectedKeys;
        if (isApply) {
          onApply({
            selectedKeys,
            savedName,
            currentActive,
            searchStr,
          });
        } else {
          onCancel();
        }
      }
    );
    helpers.updateView(this.view, {
      isSaveNameEnabled: false,
    });
  }

  render() {
    const { categories, currentActive, selected } = this.props;
    const cfg = {
      categories,
      currentActive,
      selected,
      external: true,
      searchStr: this.state.searchStr,
    };
    this.view.setState(cfg);
    return (
      <div className="bingadsgrid">
        <BackboneInstanceWrapper
          instance={this.view}
        />
      </div>
    );
  }
}
